'use strict';

var _ = require('lodash');
var RecalculatePersistModalController = function RecalculatePersistModalController($timeout, $rootScope, $scope, $window, faresOptimizerAnalysisDataService, faresOptimizerConstants) {
  $scope.initialize = function () {
    $scope.isShowConfirmMadal = false;
    $scope.isShowMovingAwayContent = false;
    $scope.isShowRecalculateModalContent = false;
    $scope.isShowSaveModalContent = false;
    $scope.isCalculatedFareHigh = undefined;
  };
  $scope.cancelAndClearDomain = function () {
    faresOptimizerAnalysisDataService.deleteRecalculatedRecommendationLadder(JSON.parse($window.sessionStorage.getItem(faresOptimizerConstants.SESSION_STORAGE_KEYS.RECALCULATED))).then(function (data) {
      if (_.isEmpty(data.failedMap)) {
        $scope.initialize();
        return $rootScope.$broadcast('foAnalysisToolbar:recalculatedFarePresent:clearRecalculatedRecommendation', true);
      } else {
        return $rootScope.$broadcast('foAnalysisToolbar:recalculatedFarePresent:clearRecalculatedRecommendation', false);
      }
    })["catch"](function () {
      $rootScope.$broadcast('foAnalysisToolbar:recalculatedFarePresent:clearRecalculatedRecommendation', false);
      $scope.isShowConfirmMadal = true;
    });
  };
  $scope.saveAsDraftRecalculatedValue = function () {
    $scope.initialize();
    // $scope.isSaveRecalculateButtonEnabled = true;
  };
  $scope.proceedToSaveRecalculatedValue = function () {
    $scope.initialize();
    $rootScope.$broadcast('foAnalysisToolbar:recalculatedFarePresent:saveRecalculatedRecommendation');
  };
  $scope.proceedWithRecalculation = function () {
    $scope.initialize();
    $rootScope.$broadcast('foAnalysisToolbar:recalculatedFarePresent:recalculateRecommendation');
  };
  $rootScope.$on('foAnalysisToolbar:recalculatedFarePresent:showConfirmModal', function (evt, param) {
    var recalculatedLadder = JSON.parse($window.sessionStorage.getItem(faresOptimizerConstants.SESSION_STORAGE_KEYS.RECALCULATED));
    $scope.initialize();
    $scope.isShowConfirmMadal = true;
    $scope[param.modalContent] = true;
    $scope.isCalculatedFareHigh = recalculatedLadder && recalculatedLadder.isRecalculatedFareHigher;
    if (!param.ignoreApply) {
      $scope.$apply();
    }
  });
};
RecalculatePersistModalController.$inject = ['$timeout', '$rootScope', '$scope', '$window', 'FaresOptimizerAnalysisDataService', 'FaresOptimizerConstants'];
module.exports = RecalculatePersistModalController;